function handleEvent(e) {
    const element = e.target.closest('[data-href]');
    const ctrlIsPresed = e.ctrlKey;
    const href = element.getAttribute('data-href');
    const target = element.getAttribute('data-target');

    if (target || ctrlIsPresed || href.indexOf('http') > -1) {
        window.open(href, target || '_blank');
    } else {
        window.location = href;
    }
}

window.addEventListener('click', event => {
    if (event.target.closest('[data-href]')) {
        handleEvent(event);
    }
}, false);
